import { useMemo } from 'react';
import useFieldValidation from 'hooks/useFieldValidation';
function getFieldLabel(name, t) {
    switch (name) {
        case 'namePL':
            return t('status_name_pl');
        case 'nameEN':
            return t('status_name_en');
        case 'color':
            return t('status_color');
        default:
            return name;
    }
}
function getFieldError(name, form, t) {
    var _a, _b;
    if (name === 'namePL')
        return !((_a = form.namePL) === null || _a === void 0 ? void 0 : _a.trim()) ? t('required_field') : null;
    if (name === 'nameEN')
        return !((_b = form.nameEN) === null || _b === void 0 ? void 0 : _b.trim()) ? t('required_field') : null;
    if (name === 'color')
        return !form.color ? t('required_field') : null;
    return null;
}
function useStatusValidation(form, t) {
    const validatedFields = useMemo(() => ['namePL', 'nameEN', 'color'], []);
    return useFieldValidation(validatedFields, (field) => getFieldError(field, form, t), (field) => getFieldLabel(field, t));
}
export default useStatusValidation;
